angular.module('app')
    .controller('ClassificazioneFondiBeiCtrl', function ($scope, $modalService, $notificationService) {
        $scope.supportModel = {
            validityQuestionario: false,
            submittedQuest: false,
            confirmButtonIsEnabled: false,
            buttonsModalEnabled: true,
            buttonConfirmIsVisible: undefined,
            email: "",
            confermaEmail: "",
            emailPresent: false,
            loaderConfirm: false,
            model: undefined
        }

        $scope.handleChange = function () {
            if ($scope.supportModel.email || $scope.supportModel.confermaEmail) {
                $scope.supportModel.emailPresent = true;
            } else {
                $scope.supportModel.emailPresent = false;
            }

            if ($scope.supportModel.confermaEmail === $scope.supportModel.email) {
                $scope.supportModel.confirmButtonIsEnabled = true;
            } else {
                $scope.supportModel.confirmButtonIsEnabled = false;
            }
        }

        $scope.exportValidityQuestionario = function (validity) {
            $scope.supportModel.validityQuestionario = validity;
        }

        $scope.exportModelQuestionario = function (model) {
            $scope.supportModel.model = model;
        }

        $scope.exportButtonConfirmIsVisible = function (value) {
            $scope.supportModel.buttonConfirmIsVisible = value;
        }

        $scope.confirmsQuestBei = function () {
            $modalService.openModal('modal');
        }

        $scope.submitQuestBei = function () {
            $scope.supportModel.buttonsModalEnabled = false;
            $scope.supportModel.loaderConfirm = true;

            $notificationService.submitQuestBei(
                $scope.supportModel.model.id,
                $scope.supportModel.model.functionId,
                $scope.supportModel.model.ndg,
                $scope.supportModel.model.societaRichiedente,
                $scope.supportModel.model.indirizzo,
                $scope.supportModel.model.codiceFiscale,
                $scope.supportModel.model.partitaIva,
                $scope.supportModel.model.rb1,
                $scope.supportModel.model.rb2,
                $scope.supportModel.model.rb3,
                $scope.supportModel.model.rb4,
                $scope.supportModel.model.numDipendenti,
                $scope.supportModel.model.codiceAteco,
                $scope.supportModel.model.rb5,
                $scope.supportModel.model.periodo,
                $scope.supportModel.model.rb6,
                $scope.supportModel.model.importo,
                $scope.supportModel.model.quotaImportoGreen,
                $scope.supportModel.model.macroSettore,
                $scope.supportModel.model.settore,
                $scope.supportModel.model.categoriaSottoprogetto,
                $scope.supportModel.model.valoreIndicatore,
                $scope.supportModel.model.descrizione,
                $scope.supportModel.model.preventivo,
                $scope.supportModel.model.anno,
                $scope.supportModel.model.indirizzoCompleto,
                $scope.supportModel.model.comune,
                $scope.supportModel.model.provincia,
                $scope.supportModel.model.cap,
                $scope.supportModel.model.stato,
                $scope.supportModel.model.convenzione,
                false,
                $scope.supportModel.email,
                $scope.supportModel.model.questionario,
                $scope.supportModel.model.cdPrd,
                $scope.supportModel.model.agevolazione1,
                $scope.supportModel.model.agevolazione2,
                $scope.supportModel.model.numeroContratto,
                $scope.supportModel.model.modulo,
                $scope.supportModel.model.tipoModulo,
                $scope.supportModel.model.internal,
                $scope.supportModel.model.emailCli
            )
                .then(function (response) {
                    if (response.filename) {
                        console.log("response", response);
                        $modalService.closeModal('modal')
                        $scope.supportModel.buttonsModalEnabled = true;
                        $scope.supportModel.loaderConfirm = false;
                        $scope.supportModel.buttonConfirmIsVisible = false;
                        $scope.supportModel.submittedQuest = true;
                    } else if (!response.success) {
                        $scope.supportModel.buttonsModalEnabled = true;
                        $scope.supportModel.loaderConfirm = false;
                    }
                })
                .catch(function (error) {
                    $scope.supportModel.loaderConfirm = false;
                    $scope.supportModel.submittedQuest = false;
                    $scope.supportModel.buttonsModalEnabled = true;
                    console.log("error", error);
                })
        }

        $scope.closeModalMail = function () {
            $modalService.closeModal('modal')
        }
    })